// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"UX-z","sponsoredTooltipWrapper":"VX-z","sponsoredTooltip":"WX-z","newCard":"XX-z"};